import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

/**
 * Soft confirmation when the operator marks a patient ready while checklist items are still
 * unchecked. Informs, never blocks ("trust people").
 */
export function ConfirmReadyDialog({
  open,
  uncheckedCount,
  onConfirm,
  onClose,
}: {
  open: boolean
  uncheckedCount: number
  onConfirm: () => void
  onClose: () => void
}) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onClose} data-testid="confirm-ready-dialog">
      <DialogTitle>{t('page.liveConsultation.checklist.confirmReady.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('page.liveConsultation.checklist.confirmReady.message', { unchecked: uncheckedCount })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('page.liveConsultation.checklist.confirmReady.cancel')}</Button>
        <Button
          variant="contained"
          color="warning"
          onClick={() => {
            onClose()
            onConfirm()
          }}
          data-testid="confirm-ready-confirm-button"
        >
          {t('page.liveConsultation.checklist.confirmReady.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
